import React from 'react';
import { formatEffectiveDate } from '../helpers';

const TermsAndConditions = () => {
  return (
    <div className="container-fluid mt-5 mb-5">
      <div className="row">
        <div className="col-12 col-lg-10 offset-lg-1">
          <h1 className="display-4 fw-800 text-dark opacity-85 mb-4">Terms and Conditions</h1>
          <div className="card shadow-sm p-4 bg-white">
            <p className="text-muted mb-4">Effective Date: {formatEffectiveDate()}</p>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">1. Acceptance of Terms</h5>
              <p className="text-dark opacity-75">
                By accessing and using www.jumpfast.tech (“Website”), you agree to comply with and be legally bound by these Terms and Conditions (“Terms”). If you do not agree to these Terms, please refrain from using our Website or services.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">2. Use of Services</h5>
              <p className="text-dark opacity-75">
                JumpFast Technologies grants you a limited, non-exclusive, non-transferable license to access and use materials on this Website for personal, non-commercial use. Any commercial use, redistribution, or modification of content without express written consent is prohibited.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">3. Intellectual Property</h5>
              <p className="text-dark opacity-75">
                All content on this Website, including but not limited to text, graphics, logos, icons, and software, is the property of JumpFast Technologies and is protected by applicable intellectual property laws. Unauthorized use may result in legal action.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">4. Disclaimer</h5>
              <p className="text-dark opacity-75">
                The materials on this Website are provided "as is". JumpFast Technologies makes no warranties, expressed or implied, and disclaims all warranties including but not limited to merchantability, fitness for a particular purpose, and non-infringement.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">5. Limitation of Liability</h5>
              <p className="text-dark opacity-75">
                In no event shall JumpFast Technologies or its partners be liable for any indirect, incidental, special, consequential or punitive damages arising out of the use or inability to use the materials on the Website or reliance on any information provided herein.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">6. Changes to Terms</h5>
              <p className="text-dark opacity-75">
                JumpFast Technologies reserves the right to modify or replace these Terms at any time. Continued use of the Website after such changes constitutes acceptance of the new Terms. It is your responsibility to review these Terms periodically.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">7. Governing Law</h5>
              <p className="text-dark opacity-75">
                These Terms shall be governed and construed in accordance with the laws of India. Any disputes arising under or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts located in New Delhi, India.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">8. Contact Information</h5>
              <p className="text-dark opacity-75">
                For any questions regarding these Terms and Conditions, please contact us at <a href="mailto:contact@jumpfast.tech" className="text-primary">contact@jumpfast.tech</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
